import React, { useEffect } from "react";
import "./EducationPage.css";

const MediaPage = () => {

  useEffect(() => {
    const cards = document.querySelectorAll(".card-wrapper");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            requestAnimationFrame(() => {
              entry.target.classList.add("show");
            });
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      {
        threshold: 0.45,
        rootMargin: "0px 0px -150px 0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, []);

  const mediaData = [
    {
      title: "Aajkaal.in",
      desc: (
        <p>
          "A real-time, online news portal catering to the Bengali diaspora, up its sleeve, makes
          Techno India Group stand out in its media endeavours. Aajkaal comes with the rich
          legacy of more than four decades, having served as an important mouthpiece of the
          Bengali readers, while also having a very decorated publication. From politics to sports,
          and business to lifestyle & entertainment, Aajkaal.in now plays a pivotal role in shaping
          opinions among Bengalis across the world."
        </p>
      ),
      img: "/images/ecosystem/aajkal.jpg",
      link: "https://www.aajkaal.in/"
    },
    {
      title: "DaakBangla.com",
      desc: (
        <p>
          "Wherever you are on this planet, if you possess a keen interest in Bengali literature,
          culture and everything that is associated with the Bengali identity then this new-age
          portal has got you covered. Coming to life on the auspicious occasion of International
          Mother Language Day in 2021, DaakBangla.com has become probably the most
          critically-acclaimed Bengali portal for shaping up refined opinions. Meanwhile, its print-
          editions, released only during the Kolkata International Book Fair, literally sells like <i>hot-kachoris</i>. ​"
        </p>
      ),
      img: "/images/ecosystem/",
      link: "https://daakbangla.com/"
    },
    {
      title: "Millennium Post",
      desc: (
        <p>
          "Over the last two decades, Millennium Post has been playing a key role in forming
          opinions among the English readers in our country. Along with a daily newspaper, it has
          a very lively online portal too, which is always on its toes. In the age of post-truth,
          Millennium Post continues to shoulder the responsibility of delivering fact-based reports,
          which are pregnant with critical analysis and supported by meticulous research. From a
          multi-faceted worldview to in-depth understanding of the socio-eco-political times of our
          country – both the newspaper and the portal, remain a joy for the English readership of
          India.​"
        </p>
      ),
      img: "/images/ecosystem/millenniumpost.jpg",
      link: "https://www.millenniumpost.in/"
    },
    // {
    //   title: "V3G Films",
    //   desc: (
    //     <p>
    //       "V3G FILMS PRIVATE LIMITED is a Private Limited Company, incorporated under the Companies Act as a Company limited by Shares."
    //     </p>
    //   ),
    //   img: "/images/ecosystem/v3gfilms.jpg",
    //   link: "#"
    // },
    // {
    //   title: "Thoughtshop",
    //   desc: (
    //     <p>
    //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged."
    //     </p>
    //   ),
    //   img: "/images/ecosystem/thoughtshop.jpg",
    //   link: "https://thotshop.in/"
    // }
  ];

  return (
    <div>

      <div className="inner-banner-wrapper">
        <img
          src="/images/page-banner/about.png"
          alt="Banner"
          className="inner-banner-img"
        />
        <div className="inner-banner-overlay">
          <div className="inner-banner-text">Media</div>
        </div>
      </div>

      <div className="overview-container">
        <div className="contain-body">

          {mediaData.map((item, index) => (
            <div
              className={`card-wrapper ${index % 2 === 1 ? "reverse" : ""}`}
              key={index}
            >

              <div className="card-text">
                <h2>{item.title}</h2>
                {item.desc}

                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="learn-more-link"
                >
                  <span className="learn-more-icon">➜</span>
                  <span>Learn more</span>
                </a>
              </div>

              <div className="card-image">
                <img src={item.img} alt={item.title} />
              </div>

            </div>
          ))}

        </div>
      </div>

    </div>
  );
};

export default MediaPage;